module.exports = __webpack_public_path__ + "media/images/diy/transforming-a-gym-into-a-banquet-hall-with-black-lights-0473d6869c31bea1ececf318c11b108e.png";